import { formatNaira } from "@/lib/formatters";
import { quoteSample, SAMPLE_THESIS, type PriceDraft } from "./thesis-pricing-fields";

export function ThesisPriceExample({ draft }: { draft: PriceDraft }) {
  const quote = quoteSample(draft);

  return (
    <div className="rounded-lg border border-slate-200 bg-slate-50 p-4">
      <p className="text-sm font-medium text-slate-900">What a student would pay</p>
      <p className="mt-1 text-xs text-slate-500">
        Example: {SAMPLE_THESIS.pages} pages, {SAMPLE_THESIS.colorPages} color pages,{" "}
        {SAMPLE_THESIS.copies} copies.
      </p>
      <dl className="mt-3 space-y-2">
        {quote.lines.map((line) => (
          <div key={line.label} className="flex items-baseline justify-between gap-4">
            <dt className="text-sm text-slate-600">
              {line.label}
              <span className="mt-0.5 block text-xs text-slate-400">{line.detail}</span>
            </dt>
            <dd className="shrink-0 text-sm tabular-nums text-slate-900">
              {formatNaira(line.amount)}
            </dd>
          </div>
        ))}
      </dl>
      <div className="mt-3 flex items-baseline justify-between border-t border-slate-200 pt-3">
        <p className="text-sm font-medium text-slate-900">Student pays</p>
        <p className="text-base font-semibold tabular-nums text-slate-900">
          {formatNaira(quote.total)}
        </p>
      </div>
    </div>
  );
}
